// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"6f86ef67","139":"9ced0aff","261":"41b52e4e","268":"b8b159f0","327":"89c2ffaa","496":"a08f3b33","593":"afc9e81b","675":"b1671423"}[chunkId] + ".chunk.js";
};